

import React from 'react';
import Image from 'react-bootstrap/Image'
import AppVars from '../../../../AppVars.js';
import Logger from '../../../../Logger.js';
import ToyotaLogo from '../../../../static/images/ty-login-logo.png'
import {constants} from '../../../../constants/constants'
import ResendLink from '../../Shared/ResendLink'
let appVars = AppVars.getInstance()
let logger = Logger.getInstance();

class ServiceFailureView extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            ...props,
    }
} 

    render(){
        return(
            <div>
                <div role = "banner">
                    <div>
                    <a href = {appVars.getAppHomeURL(this.props.style)}><Image className="login-log-resend" src={require('../../../../static/images/Toyota-Logo.svg').default} alt="Toyota"/></a>
                    </div>
                    <h1 className="title__TO block" style={{'marginBottom': '50px', 'marginTop': '79px'}}>
                    {constants.PASSWORD_SERVICE_FAILURE_TITLE}
                    </h1>
                    <div className="block">
                        <div className="subTitle__TO">{constants.PASSWORD_SERVICE_FAILURE_SUBTITLE}</div>
                    </div>
                </div>
                <ResendLink
                lineText="Need help?"
                linkAddress="/"
                linkText="CONTACT US"
                className="resend-link inline-block"
                />

            </div>
            



          
    );

    }

}




export default ServiceFailureView;